import React from "react";
import Layout from "components/Layout";
import "styles/legal.css";

const AgbsPage = () => {
  return (
    <Layout>
      <section className="legal-page">
        <div className="legal-shell">
          <p className="legal-kicker">Vertragsbedingungen</p>
          <h1>Allgemeine Geschäftsbedingungen</h1>

          <p className="legal-meta">
            Für Buchungen über dr-hoffmann-massage.de und damit verbundene
            Buchungswege der MediConsult GmbH. Stand: Juli 2026.
          </p>

          <div className="legal-toc" aria-label="Inhalt">
            <a href="#anbieter">Vertragspartner</a>
            <a href="#preise">Preise</a>
            <a href="#storno">Storno</a>
            <a href="#haftung">Haftung</a>
            <a href="#widerruf">Widerruf</a>
          </div>

          <h2 id="anbieter">1. Vertragspartner und Geltungsbereich</h2>
          <p>
            Vertragspartner für Dr. Hoffmann-Leistungen ist, soweit im
            Buchungsprozess nicht ausdrücklich ein anderer Leistungserbringer
            benannt wird:
          </p>
          <p>
            <b>MediConsult GmbH</b>
            <br />
            Cremon 11, 20457 Hamburg, Deutschland
            <br />
            Geschäftsführer Andreas Metz
            <br />
            Telefon: <a href="tel:+4940457543">+49 (0)40 457543</a>
            <br />
            E-Mail:{" "}
            <a href="mailto:info@dr-hoffmann-massage.de">
              info@dr-hoffmann-massage.de
            </a>
            <br />
            Handelsregister: HRB 176683
            <br />
            Registergericht:{" "}
            <span>Amtsgericht Hamburg</span>
            <br />
            USt-IdNr.: DE217241097
          </p>
          <p>
            Diese AGB gelten für Verbraucherinnen und Verbraucher sowie für
            Unternehmer, soweit keine individuell vereinbarte Regelung vorrangig
            ist. Verbraucher ist jede natürliche Person, die den Vertrag zu
            Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
            ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können.
          </p>

          <h2>2. Leistungen</h2>
          <p>
            Dr. Hoffmann-Massagen sind Wellness- und Aktivierungsdienstleistungen,
            insbesondere mit perkussiven Massage- und Bewegungselementen. Sie
            dienen der Entspannung, Lockerung und subjektiven Aktivierung.
          </p>
          <p>
            Die Leistungen sind keine ärztliche Behandlung, Physiotherapie,
            Heilkunde, Diagnose oder Therapie und ersetzen keine medizinische
            Abklärung. Bei Schmerzen, Erkrankungen, Schwangerschaft, frischen
            Operationen, Implantaten, Thromboseverdacht, Entzündungen,
            Hauterkrankungen oder sonstigen Risiken sollte vor der Buchung
            ärztlicher Rat eingeholt werden.
          </p>

          <h2>3. Vertragsschluss</h2>
          <p>
            Die Darstellung der Leistungen auf der Website ist noch kein
            verbindliches Angebot. Mit Anklicken des abschließenden Buchungsbuttons
            geben Kundinnen und Kunden ein verbindliches Angebot zum Abschluss
            eines Dienstleistungsvertrags ab. Der Vertrag kommt zustande, wenn die
            Buchung bestätigt wird oder die Leistung beginnt.
          </p>
          <p>
            Vor Abgabe der verbindlichen Buchung werden die wesentlichen Angaben
            zur Leistung, Termin, Ort, Preis, Zahlungsart sowie Links zu AGB,
            Datenschutzerklärung und Widerrufsbelehrung angezeigt.
          </p>

          <h2 id="preise">4. Preise und Zahlung</h2>
          <p>
            Gegenüber Verbraucherinnen und Verbrauchern verstehen sich alle im
            Buchungsprozess ausgewiesenen Preise als Endpreise einschließlich
            gesetzlicher Umsatzsteuer, soweit Umsatzsteuer anfällt. Bei
            ausdrücklich als geschäftlich oder B2B gekennzeichneten Angeboten
            können Nettopreise zuzüglich gesetzlicher Umsatzsteuer ausgewiesen
            werden.
          </p>
          <p>
            Die Zahlung erfolgt nach den im Buchungsprozess angebotenen
            Zahlungsmethoden, insbesondere online über Stripe, per Guthaben,
            vor Ort, per Zahlungslink oder nach individueller Vereinbarung.
            Online-Zahlungen werden erst über Stripe abgeschlossen.
          </p>

          <h2>5. Mitwirkung und Gesundheitshinweise</h2>
          <p>
            Kundinnen und Kunden müssen vor und während der Leistung relevante
            Umstände mitteilen, die gegen die Durchführung sprechen können. Dazu
            gehören insbesondere Schmerzen, akute Beschwerden,
            Kreislaufprobleme, Schwangerschaft, Verletzungen, frische Operationen,
            Implantate, Entzündungen, Hautveränderungen, bekannte
            Kontraindikationen oder sonstige gesundheitliche Risiken.
          </p>
          <p>
            Die MediConsult GmbH darf eine Leistung ablehnen oder abbrechen, wenn
            gesundheitliche Bedenken bestehen, Angaben fehlen oder die Durchführung
            unzumutbar ist. Gesetzliche Ansprüche bleiben unberührt.
          </p>

          <h2 id="storno">6. Stornierung, Umbuchung und Nichterscheinen</h2>
          <p>
            Kundinnen und Kunden können gebuchte Termine bis 24 Stunden vor
            Terminbeginn kostenfrei stornieren oder, soweit verfügbar, umbuchen.
          </p>
          <p>
            Bei Stornierung weniger als 24 Stunden vor Terminbeginn,
            Nichterscheinen oder selbst verschuldeter erheblicher Verspätung kann
            die MediConsult GmbH pauschal 80 % des vereinbarten Gesamtpreises als
            Ausfallvergütung verlangen. In der Pauschale sind ersparte
            Aufwendungen mit 20 % berücksichtigt. Kundinnen und Kunden dürfen
            nachweisen, dass kein oder ein wesentlich geringerer Schaden
            entstanden ist. Der MediConsult GmbH bleibt der Nachweis eines höheren
            konkreten Schadens vorbehalten.
          </p>
          <p>
            Wurde ein Termin vollständig mit Kontoguthaben bezahlt, wird dieses
            Guthaben bei einer Stornierung durch die Kundin oder den Kunden
            automatisch wieder dem Kundenkonto gutgeschrieben, sofern die
            Stornierung mindestens 24 Stunden vor Terminbeginn erfolgt. Bei
            späteren Stornierungen erfolgt keine automatische Gutschrift des
            eingesetzten Guthabens, weil der Termin kurzfristig geblockt wurde,
            Personal- und Einsatzplanung bereits erfolgt sind und eine
            anderweitige Vergabe des Zeitfensters regelmäßig nur noch erschwert
            möglich ist.
          </p>
          <p>
            Automatische Guthabengutschriften gelten nicht für Zahlungen, die
            über Stripe abgewickelt wurden. Für solche Online-Zahlungen bleiben
            gesetzliche Widerrufsrechte, insbesondere ein etwaiges
            14-tägiges Widerrufsrecht bei Fernabsatzverträgen, sowie zwingende
            Verbraucherrechte unberührt.
          </p>
          <p>
            Verspätungen können zu einer entsprechend verkürzten Leistung führen,
            wenn der Folgeterminplan dies erfordert. Bei sehr kurzer
            Terminlänge, insbesondere Wake-Up-Angeboten, kann eine erhebliche
            Verspätung faktisch zum Ausfall führen.
          </p>

          <h2>7. Absage oder Verlegung durch die MediConsult GmbH</h2>
          <p>
            Die MediConsult GmbH kann Termine aus wichtigem Grund absagen oder
            verlegen, etwa bei Krankheit, Ausfall von Personal, technischen
            Störungen, Sicherheitsbedenken, behördlichen Vorgaben oder höherer
            Gewalt. In diesem Fall wird ein Ersatztermin angeboten oder eine
            bereits geleistete Zahlung erstattet. Weitergehende gesetzliche
            Ansprüche bleiben unberührt.
          </p>

          <h2>8. Gutscheine, Guthaben, Aktionen und Rabatte</h2>
          <p>
            Gutscheine, Empfehlungsguthaben, Kampagnen-Credits und Aktionspreise
            gelten nur nach den im jeweiligen Angebot genannten Bedingungen. Sie
            sind nicht bar auszahlbar und nur kombinierbar, wenn dies ausdrücklich
            angegeben ist. Für verwendetes Kontoguthaben gilt ergänzend die
            Stornoregelung in Ziffer 6.
          </p>
          <p>
            Foto-, Film-, Marketing- oder Gesundheitsdateneinwilligungen werden
            nicht pauschal über diese AGB erteilt. Solche Einwilligungen werden
            im Buchungsprozess getrennt, freiwillig und widerruflich abgefragt.
          </p>

          <h2>9. Partner, Hotels, Mitarbeitende und Lizenznehmer</h2>
          <p>
            Leistungen können durch eigene Mitarbeitende, beauftragte Personen,
            Partnerstandorte, Hotels oder Lizenznehmer durchgeführt werden. Soweit
            im Buchungsprozess ausdrücklich ein anderer Vertragspartner benannt
            wird, kommt der Vertrag mit diesem zustande; andernfalls bleibt die
            MediConsult GmbH Vertragspartnerin.
          </p>

          <h2>10. Verhalten vor Ort</h2>
          <p>
            Kundinnen und Kunden haben sich respektvoll, hygienisch und
            rücksichtsvoll zu verhalten. Bei unangemessenem Verhalten,
            Missachtung berechtigter Hinweise, erkennbarer Alkoholisierung,
            Rauschzuständen oder Sicherheitsrisiken kann die Leistung abgelehnt
            oder beendet werden. Gesetzliche Ansprüche bleiben unberührt.
          </p>

          <h2 id="haftung">11. Haftung</h2>
          <p>
            Die MediConsult GmbH haftet unbeschränkt für Vorsatz und grobe
            Fahrlässigkeit, für Schäden aus der Verletzung des Lebens, des
            Körpers oder der Gesundheit sowie nach zwingenden gesetzlichen
            Vorschriften.
          </p>
          <p>
            Bei einfacher Fahrlässigkeit haftet die MediConsult GmbH nur bei
            Verletzung wesentlicher Vertragspflichten, deren Erfüllung die
            ordnungsgemäße Durchführung des Vertrags ermöglicht und auf deren
            Einhaltung Kundinnen und Kunden regelmäßig vertrauen dürfen. In diesem
            Fall ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden
            begrenzt.
          </p>
          <p>
            Für mitgebrachte Gegenstände haftet die MediConsult GmbH nur nach den
            gesetzlichen Vorschriften. Die vorstehenden Haftungsregelungen gelten
            auch zugunsten gesetzlicher Vertreter, Mitarbeitender und
            Erfüllungsgehilfen.
          </p>

          <h2 id="widerruf">12. Widerrufsrecht für Verbraucher</h2>
          <p>
            Bei online, telefonisch oder sonst im Fernabsatz geschlossenen
            Dienstleistungsverträgen kann Verbraucherinnen und Verbrauchern ein
            gesetzliches Widerrufsrecht zustehen. Die Widerrufsbelehrung und das
            Muster-Widerrufsformular sind nachfolgend Bestandteil dieser AGB.
          </p>

          <div className="legal-notice">
            <h3>Widerrufsbelehrung</h3>
            <p>
              Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen
              diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab
              dem Tag des Vertragsschlusses.
            </p>
            <p>
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns, MediConsult GmbH,
              Cremon 11, 20457 Hamburg, Telefon +49 (0)40 457543, E-Mail{" "}
              <a href="mailto:info@mediconsult.group">
                info@mediconsult.group
              </a>
              , mittels einer eindeutigen Erklärung, etwa Brief oder E-Mail, über
              Ihren Entschluss informieren, diesen Vertrag zu widerrufen. Sie
              können dafür das beigefügte Muster-Widerrufsformular verwenden,
              das jedoch nicht vorgeschrieben ist.
            </p>
            <p>
              Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die
              Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der
              Widerrufsfrist absenden.
            </p>

            <h3>Folgen des Widerrufs</h3>
            <p>
              Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
              die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen
              14 Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren
              Widerruf bei uns eingegangen ist. Für die Rückzahlung verwenden wir
              dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion
              eingesetzt haben, sofern nichts anderes vereinbart wurde; Entgelte
              werden Ihnen wegen dieser Rückzahlung nicht berechnet.
            </p>
            <p>
              Haben Sie verlangt, dass die Dienstleistung während der
              Widerrufsfrist beginnen soll, so haben Sie uns einen angemessenen
              Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem
              Sie uns über die Ausübung des Widerrufsrechts unterrichten, bereits
              erbrachten Leistungen im Vergleich zum Gesamtumfang der vertraglich
              vorgesehenen Leistungen entspricht.
            </p>
            <p>
              Das Widerrufsrecht erlischt bei einem Vertrag, der Sie zur Zahlung
              eines Preises verpflichtet, mit vollständiger Erbringung der
              Dienstleistung, wenn Sie vor Beginn ausdrücklich zugestimmt haben,
              dass wir mit der Leistung vor Ablauf der Widerrufsfrist beginnen,
              und Sie Ihre Kenntnis bestätigt haben, dass Ihr Widerrufsrecht bei
              vollständiger Vertragserfüllung erlischt.
            </p>

            <h3>Muster-Widerrufsformular</h3>
            <p>
              Wenn Sie den Vertrag widerrufen wollen, können Sie dieses Formular
              ausfüllen und zurücksenden:
            </p>
            <div className="legal-form-box">
              <p>
                An MediConsult GmbH, Cremon 11, 20457 Hamburg,
                info@mediconsult.group
              </p>
              <p>
                Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über
                die Erbringung der folgenden Dienstleistung:
              </p>
              <p>Bestellt am:</p>
              <p>Name der Verbraucherin/des Verbrauchers:</p>
              <p>Anschrift der Verbraucherin/des Verbrauchers:</p>
              <p>Datum:</p>
              <p>Unterschrift nur bei Mitteilung auf Papier:</p>
            </div>
          </div>

          <h2>13. Verbraucherstreitbeilegung</h2>
          <p>
            Die MediConsult GmbH ist weder verpflichtet noch bereit, an einem
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>

          <h2>14. Vertragssprache, Speicherung und Zugang zu AGB</h2>
          <p>
            Vertragssprache ist Deutsch. AGB, Datenschutzerklärung und
            Widerrufsbelehrung sind vor verbindlicher Buchung über die Website
            abrufbar und können über die Browserfunktion gespeichert oder
            ausgedruckt werden.
            <span>  
              {" "}
            </span>
          </p>

          <h2>15. Anwendbares Recht und Gerichtsstand</h2>
          <p>
            Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Gegenüber
            Verbraucherinnen und Verbrauchern bleiben zwingende
            Verbraucherschutzvorschriften des Staates des gewöhnlichen Aufenthalts
            unberührt.
          </p>
          <p>
            Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts
            oder öffentlich-rechtliches Sondervermögen, ist Hamburg Gerichtsstand.
            Für Verbraucherinnen und Verbraucher gilt der gesetzliche
            Gerichtsstand.
          </p>

          <h2>16. Schlussbestimmungen</h2>
          <p>
            Sollten einzelne Bestimmungen unwirksam sein, gelten an ihrer Stelle
            die gesetzlichen Vorschriften. Für bereits abgeschlossene Buchungen
            gelten die bei Vertragsschluss einbezogenen Bedingungen.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default AgbsPage;
